import React, {Component} from 'react';
import axios from "axios";
import config from 'react-global-configuration';
import $ from 'jquery';
import {Collapse, Label} from 'reactstrap';
//import Select from 'react-select';
import 'datatables.net';
import 'datatables.net-responsive';
import "../assets/css/datatables/datatables.min.css";
import {css} from '@emotion/core';
import {BeatLoader} from 'react-spinners';
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import '../assets/css/react-confirm-alert/react-confirm-alert.css';
import ReactTooltip from 'react-tooltip';
import {Link} from 'react-router-dom';
import jwt_decode from "jwt-decode";
import {Nav, Navbar, NavItem} from "react-bootstrap";
import CommonNavbar, {navbar} from "./commonNavbar";

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
`;
class RunPromotions extends Component {
    constructor(props){
        super(props);
        this.state = {
            unmapped_files : [],
            unmappedData: {
                id: '',
                user_id: '',
                file_name: '',
                file_path: '',
                timestamp: '',
                version: '',
                cur_version: '',
                status:'',
                user_type: ''
            },
            unmappedModel: false,
            data:[],
            loading:true,
            _notificationSystem: null,
            versions:[],
            tableLists:[],
            newRelationModel: false,
            deleteKeys:[],
            user_id: null,
            map_status: null,
            stored_file_name: null,
            file_name: null,
            userGroup: null,
            id: null,
            campaign_response: [],
            emiMenus:[]
        };
    }

    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };

    componentDidMount() {
        this._refreshCampaign();
        this.setState({ _notificationSystem: this.refs.notificationSystem });
        var _notificationSystem = this.refs.notificationSystem;
    }

    setDescription = (optionSelected) => {
        this.setState({ selectedDescription: optionSelected });
        console.log(this.state.selectedDescription)
    };
    updateSKU = (optionSelected) => {
        this.setState({ selectedSKU: optionSelected.value })
    };
    updatePrice = (optionSelected) => {
        this.setState({ selectedPrice: optionSelected.value })
    };
    
    toggleunmappedModel() {
        this.setState({
            unmappedModel: !this.state.unmappedModel
        })
    }

    _refreshCampaign() {
        if ($.fn.DataTable.isDataTable('#campaignTable')) {
            $('#campaignTable').DataTable().destroy();
        }
        axios.get(config.get('API_URL') + '/brandemi/get_campaign',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
            }).then(response => {
            console.log(response);
            this.setState({
                campaign_response: response.data
            });
            $('#campaignTable').DataTable({
                "oLanguage": {
                    "sEmptyTable": "There are no promotions created"
                }
            });
            this.setState({
                loading: false
            })

        });
    }

    mapData(id, map_status, stored_file_name, user_type, user_id, file_name){
        this.setState({
            id: id,
            map_status: map_status,
            stored_file_name: stored_file_name,
            userGroup: user_type,
            user_id: user_id,
            file_name: file_name
        });
        this.openSectionToMap(true);
    }

    openSectionToMap = (status) => {
        console.log(this.state.userGroup);
        this.setState({
            mapField: status
        })
    };

    updateMapVisiblity = (value) => {
        console.log(JSON.stringify(value));
        this.setState({
            mapField: value
        })
    };
    
    render() {
        
        let menus = this.state.emiMenus.map((menu, index) =>{
            return (
                <NavItem key={index} eventKey={index + "_" + 5} componentClass={Link} href={menu.layout+menu.path } to={menu.layout+menu.path}>
                    {menu.name}
                </NavItem>
            )
        });

        let campaign_data = this.state.campaign_response.map((value,index) => {
            let Activer = 'Inactive';
            let timer = new Date(value.start_date).toJSON().slice(0, 19).replace('T', ' ');
            let timer1 = new Date(value.end_date).toJSON().slice(0, 19).replace('T', ' ');
            let timer2 = new Date(value.record_update_timestamp).toJSON().slice(0, 19).replace('T', ' ');
            if (value.active == 1 || value.active == '1')
            {
                Activer = 'Active';
            }
            else if (value.active == -1 || value.active == '-1'){
                Activer = 'Rejected'
            }
            return (
                <tr key={index + 1}>
                    <td>{index + 1}</td>
                    <td>{value.campaign_name}</td>
                    <td>{value.campaign_desc}</td>
                    <td>{timer}</td>
                    <td>{timer1}</td>
                    <td>{value.max_cashback}</td>
                    <td>{timer2}</td>
                    
                    <td>
                        <ReactTooltip className='actionTooltip' place="bottom" type="dark" effect="solid"/>
                        <Link className="viewButton" data-tip="View Promotion Summary"  to={"/admin/admin-view-promotion/" + value.id}><span className="glyphicon glyphicon-eye-open" aria-hidden="true"></span></Link>
                    </td>
                    <td>{Activer}</td>
                </tr>
            )
        });

        return(
            <div className="content">
                <CommonNavbar/>
            <div className="card-query-builder top-pad-5 ">
                <NotificationSystem ref="notificationSystem" style={style} />
                <ReactTooltip />
                <div className="col-md-12">
                    <div className="card ">
                        <div className="header">
                            <h4 className="title">Promotions</h4>
                        </div>
                        
                        <div className='sweet-loading'>
                            <BeatLoader
                                css={override}
                                sizeUnit={"px"}
                                size={20}
                                color={'#123abc'}
                                loading={this.state.loading}
                            />
                        </div>
                        <div className="content table-full-width table-responsive">
                            <table className="table table-striped table-hover" id="campaignTable">
                                <thead>
                                <tr>
                                    <th>Sr_No.</th>
                                    <th>Promotion Name</th>
                                    <th>Promotion Description</th>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                    <th>Maximum Cashback</th>
                                    <th>Date Added</th>
                                    <th>Action</th>
                                    <th>Status</th>
                                </tr>
                                </thead>
                                <tbody>
                                    {campaign_data}
                                </tbody>
                            </table>
                        </div>
                        <div className="footer">
                            <div className="stats"><i></i></div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        );
    }
}


export default RunPromotions;